import React from 'react'
import { Grid } from '@material-ui/core'
import PageLayout from '../../common/PageLayout'
import PageHeading from '../../common/PageHeading'
import Divider from '../../../../../components/atoms/Divider'
import ModelsList from './ModelsList'

function ModelsHome () {
  return (
    <PageLayout className='font-serif' variant='constrained'>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <PageHeading title='AI Model Catalog' />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <ModelsList />
        </Grid>
      </Grid>
    </PageLayout>
  )
}

export default ModelsHome
